export const standardMsgs = [
  "Getting everything ready...",
  "Loading your workspace...",
  "Great teams start with great habits.",
  "Building a culture of feedback...",
  "Leadership grows one conversation at a time.",
];